import React from 'react';
import styled from "styled-components";

function Icon(props) {
    const {vertical, className, children, onClick, width, height, stroke} = props;

    return (
        <IconBox
            {...props}
            width={width}
            height={height}
            onClick={onClick}
            vertical={vertical}
            stroke={stroke}
            className={'icons ' + (className ? className : '')}>
            {children}
        </IconBox>
    )
}


export default React.memo(Icon);

// styles

const IconBox = styled.i`
	width: ${props => (typeof props.width !== "undefined" ? props.width + 'px' : '')};
	min-width: ${props => (typeof props.width !== "undefined" ? props.width + 'px' : '')};
	max-width: ${props => (typeof props.width !== "undefined" ? props.width + 'px' : '')};
	height: ${props => (typeof props.height !== "undefined" ? props.height + 'px' : '')};
	min-height: ${props => (typeof props.height !== "undefined" ? props.height + 'px' : '')};
	max-height: ${props => (typeof props.height !== "undefined" ? props.height + 'px' : '')};
    display: inline-flex;
    align-items: center;
    transform: ${props => props.vertical ? 'rotateY(180deg)' : ''};
    
    svg {
        width: 100%;
        height: 100%;
        stroke: ${props => props.stroke ?? ''};
        
        path, g {
          stroke: ${props => props.stroke ?? ''};
        }
    }
`;

